import { CVStepPrivacyPolicySchema } from 'schemas/cv-steps'
import { z } from 'zod'

const cVStepPrivacyPolicyValidator = CVStepPrivacyPolicySchema.extend({
  privacyAccept: z.boolean().superRefine((val, ctx) => {
    if (!val) {
      ctx.addIssue({
        code: z.ZodIssueCode.custom,
        message: `custom.acceptPrivacy`
      })
    }
  })
})

export default cVStepPrivacyPolicyValidator
